import React from 'react';
import { GlobeIcon, BellIcon, UserIcon, MenuIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { currentUser, sampleNotifications } from '../../data/sampleData';
interface HeaderProps {
  navigateTo: (page: string) => void;
}
export function Header({
  navigateTo
}: HeaderProps) {
  const {
    language,
    toggleLanguage,
    t
  } = useLanguage();
  const unreadCount = sampleNotifications.filter(n => !n.read).length;
  return <header className="bg-white h-16 border-b border-gray-200 flex items-center justify-between px-4 md:px-8 sticky top-0 z-10 shadow-sm" data-id="element-33">
      <div className="flex items-center md:hidden" data-id="element-34">
        <div className="w-8 h-8 bg-[#006A4E] rounded-full flex items-center justify-center mr-2" data-id="element-35">
          <span className="text-white font-bold text-xs" data-id="element-36">BD</span>
        </div>
        <h1 className="text-lg font-bold text-[#006A4E]" data-id="element-37">
          {t('appTitleShort')}
        </h1>
      </div>

      <div className="hidden md:flex items-center" data-id="element-38">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-39">{t('appTitle')}</h2>
      </div>

      <div className="flex items-center space-x-2 md:space-x-4" data-id="element-40">
        <button onClick={toggleLanguage} className="flex items-center space-x-1 px-3 py-1.5 rounded-full border border-gray-300 hover:bg-gray-50 text-sm font-medium text-gray-700 transition-colors" data-id="element-41">
          <GlobeIcon className="w-4 h-4 text-[#006A4E]" data-id="element-42" />
          <span data-id="element-43">{t('language')}</span>
        </button>

        <button onClick={() => navigateTo('notifications')} className="relative p-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-44">
          <BellIcon className="w-5 h-5 text-gray-600" data-id="element-45" />
          {unreadCount > 0 && <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white" data-id="element-46"></span>}
        </button>

        <button onClick={() => navigateTo('profile')} className="flex items-center space-x-2 p-1 rounded-full hover:bg-gray-100 transition-colors" data-id="element-47">
          <img src={currentUser.avatar} alt="Profile" className="w-8 h-8 rounded-full border border-gray-200" data-id="element-48" />
          <span className="hidden md:block text-sm font-medium text-gray-700 pr-2" data-id="element-49">
            {language === 'bn' ? currentUser.nameBn : currentUser.name}
          </span>
        </button>
      </div>
    </header>;
}